/**
 * Initializes menu functionality for the Tessellate theme.
 *
 * This script handles the hamburger menu toggle, mobile submenu opening/closing,
 * scroll locking, and animated fixed menu behavior on scroll and resize events.
 *
 * Key functionalities include:
 * - Toggling the hamburger menu and adjusting parent container height and position.
 * - Removing active states on desktop resize (width > 991px).
 * - Handling mobile submenu animations using scrollHeight for smooth transitions.
 * - Locking/unlocking body scroll during menu interactions.
 * - Adding/removing 'scrolled' class to top navigation and announcement banner on scroll.
 *
 * Note on submenu height: When opening a submenu, the height is set to submenu.scrollHeight + "px"
 * to animate from 0 to the full height. If you're seeing 215px instead of 430px, it might be due to
 * CSS styles (e.g., half-height or collapsed state), browser reflow issues, or the submenu not being
 * fully rendered at the time of measurement. The code sets it to the exact scrollHeight value.
 *
 * @event DOMContentLoaded - Triggers the initialization of all menu event listeners.
 * @listens click - On hamburger button and submenu links.
 * @listens resize - On window resize to reset active states.
 * @listens scroll - On window scroll for fixed menu animation.
 * @listens load - On window load to check initial scroll state.
 */
//import Example from './example';

document.addEventListener("DOMContentLoaded", function () {

    const header = this.getElementById("header");
    if (!header) return;

    //hamburger animation click trigger
    const btn = this.getElementById("hamburger");
    const topNav = this.getElementById("topNav");
    let topNavHeight = topNav.offsetHeight;
    const childDiv = btn.querySelector("div");
    const menu = document.querySelector(".vires-menu");
    const parent = menu.parentElement;
    var h = "";

    btn.addEventListener("click", () => {
        childDiv.classList.toggle("is-active");
        parent.classList.toggle("is-active");

        topNavHeight = topNav.offsetHeight;

        const offsetTop = parent.getBoundingClientRect().top + window.scrollY;

        parent.style.top = `calc(${topNavHeight}px)`;

        if (parent.classList.contains("is-active")) {
            parent.style.height = `calc(100vh - ${topNavHeight}px)`;
            lockScroll();
        } else {
            parent.style.height = ""; // reset back to CSS default
            unlockScroll();
        }
    });

    //windows resize to remove active on all mobile elemnets
    const removeActiveOnDesktop = () => {
        if (window.innerWidth > 991) {
            document.querySelectorAll(".is-active").forEach((el) => {
                el.classList.remove("is-active");
                el.removeAttribute("style");
            });
            document.querySelectorAll(".sub-menu").forEach((el) => {
                el.removeAttribute("style");
            });
        }
    };

    const recalcOpenSubmenus = () => {
        document.querySelectorAll(".sub-menu.is-active").forEach((submenu) => {
            submenu.classList.remove("is-active");
            submenu.removeAttribute("style");
        });
    };

    window.addEventListener("resize", () => {
        removeActiveOnDesktop();
        recalcOpenSubmenus();
    });

    //mobile submenu opening
    document.querySelectorAll(".menu-item-has-children > a").forEach((el) => {
        const submenu = el.nextElementSibling;
        const parent = el.parentElement;

        el.addEventListener("click", (e) => {
            if (window.innerWidth >= 991) {
                return;
            }

            e.preventDefault();

            const isOpen = submenu.classList.contains("is-active");

            if (!isOpen) {
                // OPEN
                submenu.style.height = "auto"; // let it expand naturally
                const h = submenu.scrollHeight; // get full height

                submenu.style.height = "0px"; // reset before animating
                submenu.offsetHeight; // force reflow

                submenu.style.height = h + "px"; // animate to correct height

                submenu.classList.add("is-active");
                parent.classList.add("is-active");
            } else {
                // CLOSE
                submenu.style.height = submenu.scrollHeight + "px"; // set current height
                submenu.offsetHeight; // force reflow

                submenu.style.height = "0px"; // animate closed

                submenu.classList.remove("is-active");
                parent.classList.remove("is-active");
            }
        });
    });

    //lock scrolling
    let savedScrollY = 0;

    const lockScroll = () => {
        savedScrollY = window.scrollY;

        document.body.style.position = "fixed";
        document.body.style.top = `-${savedScrollY}px`;
        document.body.style.width = "100%";
    };

    const unlockScroll = () => {
        document.body.style.position = "";
        document.body.style.top = "";
        document.body.style.width = "";

        document.documentElement.style.scrollBehavior = "auto";
        window.scrollTo(0, savedScrollY);

        // reset after
        document.documentElement.style.scrollBehavior = "";
    };

    //animated fixed menu
    window.addEventListener("scroll", function () {
        const topNav = document.getElementById("topNav");
        const announceBanner = document.getElementById("announcement_banner");

        function checkScroll() {
            topNav.classList.toggle("scrolled", window.scrollY > 80);
            if (announceBanner) announceBanner.classList.toggle("scrolled", window.scrollY > 80);
        }

        // Run on scroll
        window.addEventListener("scroll", checkScroll);

        // Run on page load
        window.addEventListener("load", checkScroll);
    });
});
